const tinyDatePicker = require('tiny-date-picker');
const dayjs = require('dayjs');

const birthday = document.querySelector('#birthday');
if (birthday) {
    const datePicker = tinyDatePicker(birthday, {
            mode: 'dp-below',
            lang: {
                days: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                months: [
                    'Januar',
                    'Februar',
                    'März',
                    'April',
                    'Mai',
                    'Juni',
                    'Juli',
                    'August',
                    'September',
                    'Oktober',
                    'November',
                    'Dezember',
                ],
                'today': '',
                'clear': 'Leeren',
                'close': 'Schließen',
            },
            format: function (date) {
                return dayjs(date).format('YYYY-MM-DD');
            },
            dayOffset: 1,
            max: dayjs().subtract(0, 'year').toDate(),
            hilightedDate: dayjs().subtract(18, 'year').toDate(),
            pickTime: false,
        })
            .on('open', () => {
                birthday.type = "text";
                birthday.classList.add('text-white', 'pe-none');
            })
            .on('close', () => {
                birthday.type = "date";
                birthday.classList.remove('text-white', 'pe-none');
                if (!datePicker.state.selectedDate) {
                    birthday.classList.add('text-white');
                }
            })
    ;
    if (!birthday.value) {
        birthday.classList.add('text-white');
    }
}
